// extracted by mini-css-extract-plugin
export default {"timeline":"timeline---k5qxu","entry":"entry---eyod8","dot":"dot---csD7e","badge":"badge---LzjHq","meta":"meta---b6T7R","noteText":"noteText---HXwRU"};